module.exports = __webpack_public_path__ + "static/henesis_ethereum_bg@2x-8aa1ca98b689ec0c7590f1f881ccc98d.png";